export default __webpack_public_path__ + "static/media/7t.94c284cb.jpg";